import '../styles/component.scss';

class RSGovernmentServiceCategories
{
	itemsContainer = null;
	paginationNodes = null;

	constructor(options = {})
	{
		this.containerId = options.containerId || '';
		this.componentName = options.componentName || '';
		this.template = options.template || '';
		this.signedParams = options.signedParams || '';
		this.siteId = options.siteId || '';
		this.siteTemplateId = options.siteTemplateId || '';
		this.ajaxUrl = options.ajaxUrl || '';
		this.useFilter = options.useFilter || false;

		BX.ready(BX.delegate(this.init,this));
	}

	init()
	{
		this.container = document.getElementById(this.containerId);

		if (!this.container)
			return false;

		this.itemsContainer = this.container.querySelector('[data-entity="items-container"]');
		this.paginationNodes = this.container.querySelectorAll('[data-pagination="'+ this.containerId +'"]');


		if (this.useFilter)
			this.initFilter();
	}

	initFilter()
	{
		const filterItems = this.container.querySelectorAll('[data-entity="nav"] .nav-link');
		if (!filterItems)
			return;

		filterItems.forEach((item) => {
			item.addEventListener('click', (event) => {
				event.preventDefault();

				const target = event.target;

				var data = {};
				data[target.getAttribute('data-name')] = target.getAttribute('data-value');

				this.loadItems(data);
				this.setFilterItemActive(target);
			});
		});
	}

	async loadItems(data)
	{
		try
		{
			this.disable();

			const result = await this.sendRequest(data);

			if (result.status != 'success')
				throw 'Error';

			this.updateItems(result.data.items);
			this.updatePagination(result.data.pagination);

			this.enable();
		}
		catch(e)
		{
			console.log(e);
		}
	}

	sendRequest(data)
	{
		return new Promise((resolve, reject) => {
			BX.ajax({
				method: 'POST',
				dataType: 'json',
				url: this.ajaxUrl,
				data: this.getData(data),
				onsuccess: resolve,
				onfailure: reject
			});
		});
	}

	getData(data)
	{
		data = data || {};

		data.site_id = this.siteId;
		data.site_template_id = this.siteTemplateId;
		data.sessid = BX.bitrix_sessid();
		data.template = this.template;
		data.signedParams = this.signedParams;

		return data;
	}

	setFilterItemActive(node)
	{
		node.parentNode.children.forEach(item => item.classList.remove('active'));
		node.classList.add('active');
	}

	updateItems(html)
	{
		if (!this.itemsContainer)
			return;

		this.itemsContainer.innerHTML = html;
	}

	updatePagination(html)
	{
		if (!this.paginationNodes)
			return;

		this.paginationNodes.forEach(item => {
			item.innerHTML = html;
		});
	}

	disable()
	{
		if (!this.itemsContainer)
			return;

		this.itemsContainer.classList.add('position-relative');

		const element = document.createElement('div');
		element.classList.add(
			'position-absolute',
			'w-100',
			'h-100',
			'd-flex',
			'justify-content-center',
			'bg-white',
			'bg-opacity-50'
		);
		element.setAttribute('data-entity', 'overlay-disable');
		this.itemsContainer.appendChild(element);

		element.innerHTML = `
			<div class="spinner-border text-primary mt-5" role="status">
				<span class="visually-hidden">Loading...</span>
	  		</div>
		`;
	}

	enable()
	{
		if (!this.itemsContainer)
			return;

		this.itemsContainer.classList.remove('position-relative');

		const element = this.itemsContainer.querySelector('[data-entity="overlay-disable"]');
		if (element)
			element.remove();
	}
}

export { RSGovernmentServiceCategories };